import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeComparers/JSONComparer/JSONComparer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeComparers/TextComparer/TextComparer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeComparers/TOMLComparer/TOMLComparer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeComparers/YAMLComparer/YAMLComparer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSObjectToJSONConverter/JSObjectToJSONConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSObjectToTOMLConverter/JSObjectToTOMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSObjectToYAMLConverter/JSObjectToYAMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSONToJSObjectConverter/JSONToJSObjectConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSONToTOMLConverter/JSONToTOMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/JSONToYAMLConverter/JSONToYAMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/PyDictToJSONConverter/PyDictToJSONConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/PyDictToTOMLConverter/PyDictToTOMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/PyDictToYAMLConverter/PyDictToYAMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/TOMLToJSObjectConverter/TOMLToJSObjectConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/TOMLToJSONConverter/TOMLToJSONConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/TOMLToYAMLConverter/TOMLToYAMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/YAMLToJSObjectConverter/YAMLToJSObjectConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/YAMLToJSONConverter/YAMLToJSONConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeConverters/YAMLToTOMLConverter/YAMLToTOMLConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/CSSFormatter/CSSFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/HTMLFormatter/HTMLFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/JSFormatter/JSFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/JSONFormatter/JSONFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/SQLFormatter/SQLFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/XMLFormatter/XMLFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeFormatters/YAMLFormatter/YAMLFormatter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMergers/JSONMerger/JSONMerger.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMergers/TOMLMerger/TOMLMerger.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMergers/YAMLMerger/YAMLMerger.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMinifiers/CSSMinifier/CSSMinifier.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMinifiers/HTMLMinifier/HTMLMinifier.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMinifiers/JSMinifier/JSMinifier.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/CodeMinifiers/JSONMinifier/JSONMinifier.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Documents/About/About.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Documents/Privacy/Privacy.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/MD5Generator/MD5Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/SHA1Generator/SHA1Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/SHA224Generator/SHA224Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/SHA256Generator/SHA256Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/SHA384Generator/SHA384Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/HashGenerators/SHA512Generator/SHA512Generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/ImageConverters/BMPConverter/BMPConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/ImageConverters/JPGConverter/JPGConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/ImageConverters/PNGConverter/PNGConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/ImageConverters/TIFFConverter/TIFFConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/ColorConverter/ColorConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/DrawLots/DrawLots.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/JSONViewer/JSONViewer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/KanaConnect/KanaConnect.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/MermaidEditor/MermaidEditor.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/OnlineClock/OnlineClock.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/QRCodeGenerator/QRCodeGenerator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/RandomStringGenerator/RandomStringGenerator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/ScreenTester/ScreenTester.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/SnowflakeIDGenerator/SnowflakeIDGenerator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/TimestampConverter/TimestampConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/Miscellaneous/WhatIsMyIP/WhatIsMyIP.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextConverters/SimplifiedTraditionalConverter/SimplifiedTraditionalConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextConverters/TabsToSpacesConverter/TabsToSpacesConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextConverters/TraditionalSimplifiedConverter/TraditionalSimplifiedConverter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/Base32Decoder/Base32Decoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/Base32Encoder/Base32Encoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/Base64Decoder/Base64Decoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/Base64Encoder/Base64Encoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/URLDecoder/URLDecoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/core/tools/TextEncoders/URLEncoder/URLEncoder.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
